<template>
    <div class="border-r border-gray-800 border-dashed">
        <div class="hidden md:flex md:w-48 lg:w-64 md:flex-col md:sticky md:top-12">
            <div class="flex flex-col flex-1 min-h-0 bg-gray-900">
                <div class="flex flex-col flex-1 overflow-y-auto">
                    <div class="flex items-center flex-shrink-0 h-12 space-x-4 text-white border-b border-gray-600">
                        <span class="px-4 text-sm">In this article</span>
                    </div>
                    <nav class="flex-1 pl-4 mt-3">
                        <router-link
                            v-for="item in contents"
                            :key="item.name"
                            :class="[item.current ? ' border-purple-500 text-purple-400' : 'text-gray-400 hover:text-white border-transparent', 'group flex items-center py-2 text-xs font-medium pl-0 border-r']"
                            :to="item.href"
                        >
                            {{ item.name }}
                        </router-link>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const contents = reactive([
    { name: "Top", href: "#", current: false }
]);

function convertToSlug (Text: string)
{
    return Text
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-") // collapse dashes
        .replace(/^-+/, "") // trim - from start of text
        .replace(/-+$/, ""); // trim - from end of text
}

function scrollToTarget (element: HTMLElement, offset: number)
{
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}

function loadHeadersFromArticle (articleRoot: HTMLElement)
{
    contents.splice(0);

    let headers = articleRoot.getElementsByTagName("h2");
    if (headers.length == 0)

        headers = articleRoot.getElementsByTagName("h1");

    let hash = router.currentRoute.value.hash;
    if (hash.startsWith("#"))

        hash = hash.substring(1);

    for (let i = 0; i < headers.length; i++)
    {
        if (!headers[i].id)
        {
            headers[i].id = convertToSlug(headers[i].innerText);
            if (headers[i].id == hash)
            {
                // If the header did not have a valid ID on page load then
                // the scroll-to behaviour won't work correctly, so we need to
                // explicitly scroll to the element.
                // TODO: The scroll position is incorrect because the images load
                // after scrolling. We need to give the images a fixed size.
                scrollToTarget(headers[i], 90);
            }
        }

        contents.push({
            name: headers[i].innerText,
            href: "#" + headers[i].id,
            current: false
        });
    }
    window.addEventListener("scroll", function ()
    {
        let activeHeader = 0;
        for (let i = 0; i < headers.length; i++)
        {
            if (contents[i])

                contents[i].current = false;

            if (headers[i].getBoundingClientRect().top < this.window.innerHeight * 0.5)

                activeHeader = i;
        }
        if (contents.length > 0 && contents[activeHeader])

            contents[activeHeader].current = true;
    });
}

onMounted(() =>
{
    refresh();
});

function refresh ()
{
    const article = document.getElementsByTagName("article");
    if (article.length > 0)

        loadHeadersFromArticle(article[0]);
}

defineExpose({
    loadHeadersFromArticle
});

</script>

<style scoped>

</style>
